import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function VerifyEmailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      verifyEmail(token);
    } else {
      setStatus('error');
      setMessage('Chýba overovací token');
    }
  }, [searchParams]);

  const verifyEmail = async (token) => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/auth/verify-email?token=${token}`, {
        credentials: 'include'
      });
      
      const data = await res.json();
      
      if (res.ok) {
        setStatus('success');
        setMessage('Váš email bol úspešne overený!');
        // Redirect to dashboard after 3 seconds
        setTimeout(() => navigate('/dashboard'), 3000);
      } else {
        setStatus('error');
        setMessage(data.detail || 'Overenie zlyhalo');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Nastala chyba pri overovaní emailu');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-white p-4">
      <Card className="max-w-md w-full p-8 text-center" data-testid="verify-email-card">
        <div className="mb-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_a65584c5-22b3-4ad8-951b-58f1980c5cae/artifacts/hts8ypom_logo_green_top.jpg" 
            alt="EVMarket Logo" 
            className="h-16 w-16 rounded-full mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-primary" style={{fontFamily: 'Manrope, sans-serif'}}>
            Overenie emailu
          </h1>
        </div>

        {status === 'loading' && (
          <div className="space-y-4">
            <Loader2 className="h-12 w-12 text-primary animate-spin mx-auto" />
            <p className="text-slate-600">Overujem váš email...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <CheckCircle2 className="h-12 w-12 text-green-500 mx-auto" />
            <p className="text-green-600 font-medium">{message}</p>
            <p className="text-slate-500 text-sm">Budete presmerovaný na dashboard...</p>
            <Button
              data-testid="go-to-dashboard-button"
              onClick={() => navigate('/dashboard')}
              className="bg-primary text-white hover:bg-slate-800"
            >
              Prejsť na dashboard
            </Button>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <XCircle className="h-12 w-12 text-red-500 mx-auto" />
            <p className="text-red-600 font-medium">{message}</p>
            <div className="space-y-2">
              <Button
                data-testid="back-to-login-button"
                onClick={() => navigate('/login')}
                className="w-full bg-primary text-white hover:bg-slate-800"
              >
                Späť na prihlásenie
              </Button>
            </div>
          </div>
        )}
      </Card>
    </div>
  );
}

export default VerifyEmailPage;
